if (!customElements.get("td-product-selector")) {
  class tdProductSelector extends HTMLElement {
    constructor() {
      super();
      this.TRIGGERS = this.querySelectorAll('[data-product-handle]');
      this.CONTAINER = document.querySelector('.section-main-product');
      this.PRODUCT_FORM = document.querySelector('[data-product-section-id]');
    }

    connectedCallback() {
      if (this.CONTAINER && this.PRODUCT_FORM) {
        this.attachListeners();
      }
    }

    attachListeners() {
      this.TRIGGERS.forEach((trigger) => {
        trigger.addEventListener("click", () => {
          this.toggleProduct(trigger);
        });
      });
    }

    toggleProduct(trigger) {
      document.body.classList.add("td-pdp-loading");
      history.replaceState(null, '', trigger.dataset.productHandle);
      this.TRIGGERS.forEach((trigger) => {trigger.classList.remove("td-active")});
      trigger.classList.add("td-active");
      const sectionId = this.PRODUCT_FORM.dataset.productSectionId;
      let requestUrl = window.location.pathname + `?section_id=${sectionId}`;
      fetch(requestUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const productForm = html.querySelector('.section-main-product');
        if (productForm) {
          this.CONTAINER.innerHTML = productForm.innerHTML;
        }
      })
      .finally(() => {
        setTimeout(() => {
          this.transitionColor(trigger.dataset.bgColor);
        }, 200);
        this.loadSmartrrScript(); // Inject the smartrr script after toggling the product
        document.dispatchEvent(new CustomEvent('td:section-rendered', { bubbles: true }));
      })
      .catch(e => {
        console.error(e);
      });
    }

    transitionColor(color) {
      document.body.setAttribute("style", `--td-product-bg-color: ${color}`);
    }

    loadSmartrrScript() {
      console.log('Injecting smartrr-product-script...');
      
      // Remove existing script if it exists
      const existingScripts = document.querySelectorAll('script[src*="smartrr-product-script.js"]');
      const existingSmartrrProdScripts = document.querySelectorAll('.smartrr-prod-script');
      let existingSmartrrProdScriptContent;
      
      if (existingScripts.length && existingSmartrrProdScripts.length) {
        Array.from(existingScripts).forEach((existingScript) => {
          existingScript.remove()
        })
      
        Array.from(existingSmartrrProdScripts).forEach((existingSmartrrProdScript, i) => {
          if (i === 0) {
            existingSmartrrProdScriptContent = existingSmartrrProdScript.text;
          } 
          existingSmartrrProdScript.remove()
        })
      }
      
      // if (existingScript && existingSmartrrProdScript) {
      //   existingSmartrrProdScriptContent = existingSmartrrProdScript.text;
      //   console.log("existingSmartrrProdScriptContent", existingSmartrrProdScript.text);
      //   existingScript.remove();
      //   console.log("existingScript removed", existingScript)
      //   existingSmartrrProdScript.remove();
      //   console.log("existingSmartrrProdScript removed", existingSmartrrProdScript)
      // }

      // Create a new script element
      const scriptElement = document.createElement('script');
      const smartrrScriptElement = document.createElement('script');
      scriptElement.type = 'text/javascript';
      scriptElement.src = 'https://www.livibeauty.com/cdn/shop/t/13/assets/smartrr-product-script.js';
      smartrrScriptElement.text = existingSmartrrProdScriptContent;
      smartrrScriptElement.classList.add('smartrr-prod-script');

      // Append the script to the body to execute it
      const productForm = document.querySelector('[data-smartrr-form-id]');
      productForm.appendChild(scriptElement);
      productForm.appendChild(smartrrScriptElement);
      // document.body.appendChild(scriptElement);
      // document.body.appendChild(smartrrScriptElement);
    }
  }

  customElements.define('td-product-selector', tdProductSelector);
}
